import { render, staticRenderFns } from "./form-folders.vue?vue&type=template&id=886a2b50&scoped=true&lang=pug"
import script from "./form-folders.vue?vue&type=script&lang=js"
export * from "./form-folders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886a2b50",
  null
  
)

export default component.exports